import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/list-sharing-controller',{init:init})

function init(div){
   var 
    select = div.find("select").first(),
    sharedToAll = div.find("input[name='sharedToAll']"),
    explain =  div.find("[data-ontype]"),
    details = div.parent().find('[data-widget="widget/user-picker"]');

   var
     selectedValue = select.attr("data-fw-select-value");
     select
       .find( "option[value='"+selectedValue+"']")
       .prop('selected',true);
   
    select.on('change',function(){
      if(this.value==='all'){
        sharedToAll.val('true');
        details.hide();
        details.trigger('clear')
      }else if(this.value==='none'){
        sharedToAll.val('false');
        details.hide();
        details.trigger('clear')
      }else{
        sharedToAll.val('false');
        details.show();
      }
      explain.each((idx,obj)=>{
        $(obj).toggle($(obj).attr('data-ontype')===this.value)
      })
    }).trigger('change')
  
  
}